const pageView = (content) => ({selector: '[data-tut="page-view"]', content});

const TOURS = [
  {
    id: 'dashboard',
    match: /^\/dashboard\/app\/?$/,
    title: 'Visão geral da 1Lead',
    intro: 'Em cerca de 2 minutos, você verá como pesquisar empresas, criar listas, iniciar campanhas de vendas e acompanhar respostas em um só lugar.',
    steps: [
      {
        selector: '[data-tut="dashboard-view"]',
        content: 'A visão geral reúne os resultados da equipe por período: empresas, campanhas e vendas.',
      },
      {
        selector: '[data-tut="credits"]',
        content: 'Este saldo limita quantos leads podem ser gerados. Estimativas e prévias não consomem créditos; a cobrança considera apenas os leads entregues.',
      },
      {
        selector: '[data-tut="notifications"]',
        content: 'As notificações avisam sobre respostas, enriquecimentos, aquecimento de e-mail, campanhas concluídas e negócios ganhos.',
      },
      {
        selector: '[data-tut="campaigns"]',
        content: 'Pesquisas encontra empresas a partir do seu objetivo e ICP, permite revisar filtros e mostra volume e amostra antes de gerar a lista.',
        adminOnly: true,
      },
      {
        selector: '[data-tut="leads"]',
        content: 'Leads oferece uma lista para consulta e um funil para organizar responsáveis, atividades e o avanço de cada oportunidade.',
        position: 'left',
      },
      {
        selector: '[data-tut="contacts"]',
        content: 'Contatos reúne as pessoas vinculadas aos leads, com cargo, e-mail, telefone e dados enriquecidos disponíveis.',
      },
      {
        selector: '[data-tut="mailbox"]',
        content: 'A Caixa de entrada centraliza conversas das contas conectadas para você ler e responder sem perder o contexto comercial.',
      },
      {
        selector: '[data-tut="outreachCampaigns"]',
        content: 'Em Campanhas de vendas, envie mensagens às empresas de uma pesquisa e acompanhe as respostas.',
      },
      {
        selector: '[data-tut="teams"]',
        content: 'Em Times, administradores convidam a equipe e distribuem leads e campanhas entre responsáveis.',
        adminOnly: true,
      },
      {
        selector: '[data-tut="settings"]',
        content: 'Em Configurações, atualize sua conta, os perfis de cliente ideal, as contas de e-mail e as etapas do quadro de vendas.',
      },
      {
        selector: '[data-tut="workspace-switcher"]',
        content: 'O seletor troca a operação ativa. Dashboard, leads, campanhas, e-mails e permissões acompanham o workspace escolhido.',
      },
    ],
  },
  {
    id: 'searches',
    match: /^\/dashboard\/campaigns\/list\/?$/,
    title: 'Pesquisas de empresas',
    intro: 'Veja como localizar pesquisas, acompanhar a geração de leads e iniciar uma nova busca guiada.',
    steps: [
      {
        selector: '[data-tut="campaigns-view"]',
        content: 'Esta página reúne suas pesquisas e mostra o progresso de cada lista de empresas gerada.',
        position: 'top',
      },
      {
        selector: '[data-tut="search-bar"]',
        content: 'Use a busca para localizar uma pesquisa pelo nome sem percorrer toda a lista.',
      },
      {
        selector: '[data-tut="table-row-0"]',
        content: 'Cada linha resume responsável, quantidade de empresas, créditos usados, status e progresso da geração.',
      },
      {
        selector: '[data-tut="edit-table-row-0"]',
        content: 'As ações permitem revisar detalhes e distribuição ou excluir uma pesquisa que não precisa ser mantida.',
      },
      {
        selector: '[data-tut="create-button"]',
        content: 'Nova Pesquisa abre o fluxo guiado: informe o objetivo e o ICP, valide filtros, confira a estimativa e a prévia sem custo e confirme os créditos antes de gerar leads.',
      },
    ],
  },
  {
    id: 'guided-search',
    match: /^\/dashboard\/campaigns\/guided-search\/?$/,
    title: 'Busca guiada de leads',
    intro: 'Passe da descrição do seu negócio à lista pronta, sempre revisando critérios, destino e custo antes da confirmação.',
    steps: [
      pageView('A busca guiada usa seu perfil, objetivo e público para sugerir critérios; nenhuma sugestão é aplicada sem sua revisão.'),
      {
        selector: '[aria-label="Progresso da busca guiada"]',
        content: 'O progresso mostra em qual decisão você está: perfil, objetivo, público, filtros, distribuição ou revisão final.',
      },
      {
        selector: '[aria-label="Revisar resumo da busca"]',
        content: 'O resumo mantém critérios, estimativa e destino visíveis para você conferir o efeito de cada alteração.',
      },
      {
        selector: '[data-tut="credits"]',
        content: 'A análise e a amostra não gastam créditos. A reserva ocorre somente após sua confirmação e é reconciliada pelos leads entregues.',
      },
    ],
  },
  {
    id: 'new-search',
    match: /^\/dashboard\/(?:campaigns\/(?:new|guided-new|guided-legacy)|pesquisas\/nova)\/?$/,
    title: 'Nova pesquisa',
    intro: 'Escolha um ponto de partida e avance até uma amostra revisável antes de gerar qualquer lead.',
    steps: [
      pageView('Comece por um ICP salvo, um site ou uma descrição. A IA sugere segmentos, CNAEs e filtros que você pode ajustar ou remover.'),
      {
        selector: '[data-tut="credits"]',
        content: 'Estimativa e prévia não consomem saldo. Antes de gerar, você escolhe a quantidade e vê o limite pelos resultados e créditos disponíveis.',
      },
      {
        selector: '[data-tut="campaigns"]',
        content: 'Ao concluir, a pesquisa fica salva aqui para acompanhar a geração e abrir a lista resultante.',
        adminOnly: true,
      },
    ],
  },
  {
    id: 'search-details',
    match: /^\/dashboard\/campaigns\/[^/]+\/edit\/?$/,
    title: 'Detalhes da pesquisa',
    intro: 'Revise o resultado da busca, a distribuição e os leads associados.',
    steps: [
      pageView('Esta tela consolida critérios, geração e distribuição da pesquisa selecionada.'),
      {
        selector: '[data-tut="campaigns"]',
        content: 'Volte a Pesquisas para comparar status, consumo e progresso com as demais listas.',
        adminOnly: true,
      },
      {
        selector: '[data-tut="leads"]',
        content: 'Os leads entregues ficam disponíveis na lista e no funil para o trabalho comercial.',
      },
    ],
  },
  {
    id: 'lead-list',
    match: /^\/dashboard\/leads\/list\/?$/,
    title: 'Lista de leads',
    intro: 'Encontre empresas geradas, filtre a lista e encaminhe os leads para o funil.',
    steps: [
      pageView('A lista concentra empresas, origem da pesquisa, responsáveis e dados disponíveis para prospecção.'),
      {selector: 'main input', content: 'Pesquise pelo nome da empresa e combine o termo com o filtro de pesquisa de origem.'},
      {selector: 'main table', content: 'Selecione registros para exportar, sincronizar ou mover para o funil; abra uma linha para consultar seus detalhes.'},
      {selector: '[data-tut="leads"]', content: 'Alterne entre Empresas e Funil pelo menu Leads.'},
    ],
  },
  {
    id: 'lead-board',
    match: /^\/dashboard\/leads(?:\/board)?\/?$/,
    title: 'Funil de vendas',
    intro: 'Organize oportunidades por etapa e mantenha prioridade e responsabilidade visíveis.',
    steps: [
      pageView('Cada cartão representa uma oportunidade. Arraste cartões entre etapas para refletir o avanço comercial.'),
      {selector: '#campaign-filter', content: 'Filtre o funil pela pesquisa que originou os leads.'},
      {selector: '#assigned-to-filter', content: 'Mostre somente oportunidades atribuídas a pessoas específicas.'},
      {selector: '[data-rbd-droppable-id="all-columns"]', content: 'As colunas representam as etapas do processo; a ordem e os nomes podem ser configurados por administradores.'},
    ],
  },
  {
    id: 'lead-details',
    match: /^\/dashboard\/leads\/[^/]+(?:\/edit)?\/?$/,
    title: 'Detalhes do lead',
    intro: 'Reúna dados da empresa, contatos, inteligência e histórico em um único registro.',
    steps: [
      pageView('Use esta página para revisar a empresa, atualizar o responsável e registrar o contexto necessário para a próxima ação.'),
      {selector: '[data-tut="contacts"]', content: 'Os contatos vinculados ficam reunidos em Contatos para consulta e enriquecimento.'},
      {selector: '[data-tut="leads"]', content: 'Retorne à lista ou ao funil sem perder as alterações salvas neste lead.'},
    ],
  },
  {
    id: 'contact-list',
    match: /^\/dashboard\/contacts\/(?:list|cards)\/?$/,
    title: 'Contatos',
    intro: 'Localize as pessoas associadas aos leads e confira os canais disponíveis para abordagem.',
    steps: [
      pageView('Contatos reúne nome, cargo, empresa, e-mail, telefone e dados enriquecidos quando disponíveis.'),
      {selector: 'main input', content: 'Use a busca para localizar uma pessoa ou empresa rapidamente.'},
      {selector: 'main table', content: 'A tabela permite selecionar, abrir, enriquecer ou remover contatos conforme sua permissão.'},
      {selector: '[data-tut="mailbox"]', content: 'Abra a Caixa de entrada para acompanhar as conversas geradas pela abordagem.'},
    ],
  },
  {
    id: 'contact-details',
    match: /^\/dashboard\/contacts\/(?:new|[^/]+\/edit)\/?$/,
    title: 'Cadastro de contato',
    intro: 'Crie ou atualize os dados de uma pessoa vinculada à operação comercial.',
    steps: [
      pageView('Preencha os dados conhecidos, associe a pessoa à empresa correta e salve apenas informações confiáveis.'),
      {selector: '[data-tut="contacts"]', content: 'Após salvar, o contato volta a aparecer na lista central.'},
      {selector: '[data-tut="leads"]', content: 'Consulte o lead relacionado para manter o contexto da empresa e da oportunidade.'},
    ],
  },
  {
    id: 'inbox',
    match: /^\/dashboard\/mail(?:\/.*)?$/,
    title: 'Caixa de entrada',
    intro: 'Centralize as conversas das contas conectadas e responda com o contexto do lead.',
    steps: [
      pageView('Escolha uma caixa ou pasta, abra a conversa e acompanhe mensagens de todas as contas conectadas ao workspace.'),
      {selector: 'main input[placeholder="Buscar por assunto ou contato"]', content: 'Pesquise conversas por assunto, nome ou endereço do contato.'},
      {selector: '[data-tut="mailbox"]', content: 'O contador e as pastas ajudam a priorizar mensagens ainda não lidas.'},
      {selector: '[data-tut="settings"]', content: 'Em Configurações, conecte caixas próprias ou gerencie a infraestrutura de e-mail contratada.'},
    ],
  },
  {
    id: 'outreach-list',
    match: /^\/dashboard\/outreach-campaigns\/list\/?$/,
    title: 'Campanhas de vendas',
    intro: 'Abra uma campanha para acompanhar os envios e saber quem respondeu.',
    steps: [
      pageView('O resumo mostra volume de campanhas, leads e mensagens enviadas no workspace.'),
      {selector: 'main input[placeholder="Buscar por campanha, site ou segmento"]', content: 'Localize uma campanha pelo nome, site analisado ou segmento.'},
      {selector: '[aria-label="Filtrar por status"]', content: 'Filtre campanhas em rascunho, agendadas, ativas, pausadas, concluídas ou com erro.'},
      {selector: 'main table[aria-label="Campanhas de vendas"]', content: 'Abra uma campanha para revisar o público, editar as mensagens ou acompanhar os envios.'},
    ],
  },
  {
    id: 'outreach-details',
    match: /^\/dashboard\/outreach-campaigns\/[^/]+\/?$/,
    title: 'Como usar sua campanha',
    intro: 'Prepare o público e as mensagens, inicie a campanha e acompanhe as respostas.',
    steps: [
      pageView('No topo, veja a situação da campanha e a ação disponível: revisar e iniciar, pausar ou retomar.'),
      {selector: '[data-testid="outreach-tabs"]', content: 'Visão geral mostra o andamento. Público reúne as empresas. Mensagens permite editar os textos. Envios mostra as mensagens enviadas e na fila. Atividade reúne os acontecimentos da campanha. Configurações reúne as contas e os horários.'},
      {selector: '[data-testid="outreach-details-card"]', content: 'Na visão geral, clique em um indicador para ver as empresas ou mensagens correspondentes. Os resultados detalhados ficam sempre visíveis. Consulte o histórico na aba Atividade.'},
      {selector: '[data-tut="mailbox"]', content: 'As respostas recebidas também aparecem na Caixa de entrada centralizada.'},
    ],
  },
  {
    id: 'team-list',
    match: /^\/dashboard\/teams\/(?:list|cards)\/?$/,
    title: 'Times',
    intro: 'Organize grupos de trabalho usados para distribuir leads e campanhas.',
    steps: [
      pageView('A lista mostra times, descrição e status; administradores podem criar, editar ou desativar grupos.'),
      {selector: 'main input', content: 'Pesquise um time pelo nome antes de alterar seus integrantes ou configuração.'},
      {selector: 'main table', content: 'Selecione ou abra um time para revisar sua composição e disponibilidade.'},
      {selector: '[data-tut="workspace-switcher"]', content: 'Times pertencem ao workspace ativo; troque de workspace para ver outra estrutura.'},
    ],
  },
  {
    id: 'team-details',
    match: /^\/dashboard\/teams\/(?:new|[^/]+\/edit)\/?$/,
    title: 'Configuração do time',
    intro: 'Defina o grupo que receberá leads e responsabilidades na operação.',
    steps: [
      pageView('Informe nome, descrição, status e participantes do time e salve para disponibilizá-lo na distribuição.'),
      {selector: '[data-tut="teams"]', content: 'Retorne a Times para comparar ou gerenciar os demais grupos.'},
      {selector: '[data-tut="workspace-switcher"]', content: 'A configuração é aplicada somente ao workspace atualmente selecionado.'},
    ],
  },
  {
    id: 'account',
    match: /^\/dashboard\/user\/account\/?$/,
    title: 'Configurações da conta',
    intro: 'Gerencie perfil, e-mail, workspaces e segurança no mesmo lugar.',
    steps: [
      pageView('As opções disponíveis respeitam sua conta, plano e permissões no workspace.'),
      {selector: 'main [role="tablist"]', content: 'Alterne entre dados gerais, configuração de e-mail, workspaces e senha.'},
      {selector: '[data-tut="workspace-switcher"]', content: 'O seletor define qual workspace será afetado por caixas, membros e demais configurações operacionais.'},
      {selector: '[data-tut="settings"]', content: 'Use o submenu Configurações para acessar os perfis de cliente ideal e as etapas do quadro de vendas.'},
    ],
  },
  {
    id: 'icps',
    match: /^\/dashboard\/user\/icps\/?$/,
    title: 'Perfis de cliente ideal',
    intro: 'Salve públicos recorrentes para começar novas pesquisas com mais contexto e menos digitação.',
    steps: [
      pageView('Você pode manter até cinco ICPs com descrição das empresas desejadas e gatilhos de compra.'),
      {selector: 'main input[aria-label^="Nome do ICP"]', content: 'Dê um nome fácil de reconhecer e descreva com precisão quais empresas pertencem ao perfil.'},
      {selector: '[data-tut="campaigns"]', content: 'Na próxima pesquisa, escolha um ICP salvo como ponto de partida e revise todas as sugestões antes de usar.', adminOnly: true},
      {selector: '[data-tut="settings"]', content: 'Os ICPs ficam em Configurações e podem ser atualizados conforme sua estratégia muda.'},
    ],
  },
  {
    id: 'funnel-settings',
    match: /^\/dashboard\/config\/kanban\/?$/,
    title: 'Etapas do funil',
    intro: 'Modele as etapas usadas pela equipe para acompanhar oportunidades.',
    steps: [
      pageView('Crie nomes que representem o processo real e ordene as etapas na sequência usada pela equipe.'),
      {selector: '[data-rbd-droppable-id="all-columns"]', content: 'Arraste as colunas para alterar a ordem; os cartões do funil passam a seguir esta configuração.'},
      {selector: '[data-tut="leads"]', content: 'Abra o Quadro de vendas em Empresas e vendas para usar as etapas configuradas.'},
      {selector: '[data-tut="settings"]', content: 'Somente usuários autorizados devem alterar uma estrutura compartilhada por toda a operação.'},
    ],
  },
];

const FALLBACK_TOUR = {
  id: 'dashboard-page',
  title: 'Tutorial desta página',
  intro: 'Veja o objetivo desta tela e como ela se conecta ao restante do dashboard.',
  steps: [
    pageView('Esta é a área principal da página. Use o título e as ações disponíveis para identificar o fluxo atual.'),
    {selector: '[data-tut="mode"]', content: 'Alterne entre os temas claro e escuro; o tutorial acompanha o tema selecionado.'},
  ],
};

export function getDashboardTour(pathname, {isAdmin = false} = {}) {
  const tutorial = TOURS.find(({match}) => match.test(pathname)) || FALLBACK_TOUR;
  return {
    ...tutorial,
    steps: tutorial.steps
      .filter((step) => !step.adminOnly || isAdmin)
      .map(({adminOnly, ...step}) => step),
  };
}

export default getDashboardTour;
